/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".form-horizontal.titulo[_ngcontent-%COMP%] {\r\n    margin-top: 25px !important;\r\n}"];
export { styles as styles };
